import React from 'react';
import { TrendingUp, Shield, Lightbulb } from 'lucide-react';
export const AboutSection = () => {
  return <section id="about" className="py-16 md:py-24 bg-white" data-id="element-13">
      <div className="container mx-auto px-4 md:px-6" data-id="element-14">
        <div className="max-w-3xl mx-auto text-center mb-12 md:mb-16" data-id="element-15">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-aspira-navy" data-id="element-16">
            About Aspira Works
          </h2>
          <p className="text-aspira-gray text-lg" data-id="element-17">
            We provide strategies and solutions to grow, professionalize, and
            optimize your business.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-18">
          <div className="bg-aspira-white p-6 rounded-xl shadow-sm" data-id="element-19">
            <div className="w-12 h-12 bg-aspira-green bg-opacity-10 rounded-full flex items-center justify-center mb-4" data-id="element-20">
              <TrendingUp className="text-aspira-green" size={24} data-id="element-21" />
            </div>
            <h3 className="text-xl font-semibold mb-3 text-aspira-navy" data-id="element-22">
              Growth
            </h3>
            <p className="text-aspira-gray" data-id="element-23">
              We help businesses identify growth opportunities and develop
              executable plans to maximize potential.
            </p>
          </div>
          <div className="bg-aspira-white p-6 rounded-xl shadow-sm" data-id="element-24">
            <div className="w-12 h-12 bg-aspira-blue bg-opacity-10 rounded-full flex items-center justify-center mb-4" data-id="element-25">
              <Lightbulb className="text-aspira-blue" size={24} data-id="element-26" />
            </div>
            <h3 className="text-xl font-semibold mb-3 text-aspira-navy" data-id="element-27">
              Innovation
            </h3>
            <p className="text-aspira-gray" data-id="element-28">
              Our innovative approaches help businesses reimagine their
              operations and discover new avenues for success.
            </p>
          </div>
          <div className="bg-aspira-white p-6 rounded-xl shadow-sm" data-id="element-29">
            <div className="w-12 h-12 bg-aspira-orange bg-opacity-10 rounded-full flex items-center justify-center mb-4" data-id="element-30">
              <Shield className="text-aspira-orange" size={24} data-id="element-31" />
            </div>
            <h3 className="text-xl font-semibold mb-3 text-aspira-navy" data-id="element-32">
              Trust
            </h3>
            <p className="text-aspira-gray" data-id="element-33">
              We build long-lasting partnerships based on trust, transparency,
              and delivering measurable results.
            </p>
          </div>
        </div>
        <div className="mt-16 bg-gradient-to-r from-aspira-navy to-aspira-blue p-8 md:p-12 rounded-xl text-white" data-id="element-34">
          <div className="md:flex items-center justify-between" data-id="element-35">
            <div className="md:w-3/5 mb-6 md:mb-0" data-id="element-36">
              <h3 className="text-2xl md:text-3xl font-bold mb-3" data-id="element-37">
                Aspire, Grow, and Succeed with Aspira Works
              </h3>
              <p className="text-aspira-white opacity-90" data-id="element-38">
                Our mission is to help your business achieve a positive growth
                cycle and focus on your core mission.
              </p>
            </div>
            <div data-id="element-39">
              <a href="#contact" className="inline-block bg-aspira-green hover:bg-opacity-90 text-white px-6 py-3 rounded-md transition-colors font-medium text-center" data-id="element-40">
                Start Your Growth Journey
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
};